import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { FormResponseValueAnswer } from "@tellescope/types-models";

const REPEATABLE_TYPES = ["string", "stringLong", "number"] as const;

const isRepeatableType = (type: string): boolean => (REPEATABLE_TYPES as readonly string[]).includes(type);

export interface IsRepeatMismatchArgs {
  field: TellescopeModelFromName<"form_fields">;
  value: FormResponseValueAnswer["value"];
  confirmation: string;
}

/**
 * Whether a repeat ("confirm your entry") field's two inputs disagree.
 *
 * The comparison is unconditional: an empty primary with a non-empty confirmation counts as a
 * mismatch even on an optional field, so a stray confirmation is surfaced rather than silently
 * accepted.
 */
export const isRepeatMismatch = ({ field, value, confirmation }: IsRepeatMismatchArgs): boolean => {
  if (!field.options?.repeat) return false;
  if (!isRepeatableType(field.type)) return false;

  const primary = typeof value === "string" ? value : typeof value === "number" ? String(value) : "";
  return primary !== confirmation;
};
